import { render } from "./bread_crumbs.vue?vue&type=template&id=645d4170"
import script from "./bread_crumbs.vue?vue&type=script&lang=js"
export * from "./bread_crumbs.vue?vue&type=script&lang=js"

import "./bread_crumbs.vue?vue&type=style&index=0&id=645d4170&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__